import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MemberService } from 'src/app/component/members/member-service/member.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-member-status-modal',
  templateUrl: './member-status-modal.component.html',
  styleUrls: ['./member-status-modal.component.css']
})
export class MemberStatusModalComponent implements OnInit {
  @Input() members
  @Output() closeModal = new EventEmitter<any>()
  memberStatusForm : UntypedFormGroup

  constructor(
    private memberService : MemberService, 
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit() {
    console.log("Selected",this.members);
    this.memberStatusForm = this.fb.group({
      accountStatus:['']
    })
  }
  onCloseModal(){
    this.closeModal.emit();
  }

  onUpdate(){
    // ----
    sweetAlert('Alert','Are you sure you want to update status?', 'warning', 'Yes', 'No')
    .then((result) => {
      if (result.value) {
        const payload = {
          _ids : this.members,
          accountStatus : this.memberStatusForm.value.accountStatus
         }
         this.memberService.updateMemberStatus(payload).subscribe((data)=>{
          if(data){
            this.closeModal.emit({
              status: this.memberStatusForm.value.accountStatus
            });
          }
        })
         , err => {
            sweetAlert('Error', err, 'error', 'Ok');
          };
      } 
    });


// ------

  
   
  }
}
